import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetBase } from '../widget-content/base/widget-base';
import { fiTryContentLanguageValue } from '@fi-shared/utils/try-content-language-value';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { WidgetModel } from '../model/widget.model';
import { isFunction } from '@fi-shared/utils/is-function';
import { AppTextService } from '@fi-shared/app-text';
import { fiWidgetGetTextId } from '@fi-shared/widget/widget-registry';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { WidgetContentModel } from '@fi-app/widget/model/widget-content.model';

@Component({
    selector: 'fi-widget',
    templateUrl: './widget.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./widget.component.scss'],
    host: { class: 'fi-widget' },
    standalone: false,
})
export class WidgetComponent implements OnInit {
    @Input() widget: WidgetModel;
    @Input() control: WidgetPlaceHolderControlModel;
    @Input() languageId: number;

    contentComponent: WidgetBase;

    private _isEmpty: boolean = true;
    @HostBinding('class.not-empty')
    get isClassNotEmpty() {
        return !this._isEmpty;
    }

    defaultLanguage: any;
    defaultApplicationLanguage: any;

    constructor(
        private appTextService: AppTextService,
        private contentLanguageSharedService: FiContentLanguageSharedService,
        private userDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        if (isFunction(this.widget.onControlInitialized)) {
            this.widget.onControlInitialized(this.control);
        }

        this.defaultLanguage = this.userDataService.userData.PreferredContentLanguage;
        this.defaultApplicationLanguage = this.contentLanguageSharedService.getDefaultContentLanguageId();
    }

    IsShowContainer() {
        return this.control.Settings.DisplayContainer == undefined || this.control.Settings.DisplayContainer === true;
    }

    IsShowHeader() {
        return this.control.Settings.DisplayHeader == undefined || this.control.Settings.DisplayHeader === true;
    }

    GetHeaderTitle() {
        if (this.control.Settings.HeaderNames) {
            const headerTitle =
                this.control.Settings.HeaderNames[this.languageId] ||
                this.control.Settings.HeaderNames[this.defaultLanguage] ||
                this.control.Settings.HeaderNames[this.defaultApplicationLanguage];
            if (headerTitle) return headerTitle;
        } else if (this.control.Names) {
            const title =
                fiTryContentLanguageValue(this.control.Names, this.languageId) ||
                fiTryContentLanguageValue(this.control.Names, this.defaultLanguage);
            if (title) {
                return title;
            }
        }

        return this.control.Name || this.appTextService.get(fiWidgetGetTextId(this.widget.WidgetType));
    }

    widgetViewInit(component: WidgetBase) {
        setTimeout(() => {
            this.contentComponent = component;
            if (component.isEmpty$) {
                component.isEmpty$.subscribe((v) => {
                    this._isEmpty = v;
                });
            }
        });
    }
}
